import {
	filtersPolishSelector,
	isInFiltersPolishExperiment,
} from '@client/redux/experiments/selectors/filters-polish';
import { useAppDispatch, useAppSelector } from '@client/redux/hooks';
import { reportServerSideExperiment } from '@redux/experiments';
import { experiments } from '@settings';
import { Link } from '@tkww/orion-web-ds-action';
import { Logger } from '@utils/logger/logger';
import classNames from 'classnames';
import React, { useEffect, type FC } from 'react';
import type { DropdownChildProps } from '../../DropdownProps';
import Dropdown from '../../components';
import SaveButton from '../../components/SaveButton';
import Styles from '../../styles.scss';

interface DesktopDropdownProps extends DropdownChildProps {
	modalHeader: string;
}

const DesktopDropdown: FC<DesktopDropdownProps> = (props) => {
	const { modalHeader, onSave, ...dropdownProps } = props;
	const filtersPolishAssignment = useAppSelector(filtersPolishSelector);
	const isFilterPolishEnabled = useAppSelector(isInFiltersPolishExperiment);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (filtersPolishAssignment) {
			Logger.log({
				log_message: `Filters Polish Assignment: ${filtersPolishAssignment}`,
			});

			void dispatch(reportServerSideExperiment(experiments.filtersPolish));
		}
	}, [filtersPolishAssignment, dispatch]);

	const clearSelections = () => {
		props.setStagedOptions([]);
	};
	return (
		<div className={Styles.dropdown}>
			<Dropdown
				modalHeader={modalHeader}
				isFilterPolishEnabled={isFilterPolishEnabled}
				{...dropdownProps}
			/>
			<div
				className={classNames(Styles.ctaSection, {
					[Styles['cta-section--filter-polish']]: isFilterPolishEnabled,
				})}
			>
				<Link
					as="button"
					onClick={clearSelections}
					className={Styles.clear}
					type="reset"
				>
					Clear
				</Link>
				<SaveButton
					disabled={false}
					onSave={onSave}
					stagedOptions={props.stagedOptions}
					isDesktopDropdown={isFilterPolishEnabled}
				>
					{isFilterPolishEnabled ? 'Apply' : 'Save'}
				</SaveButton>
			</div>
		</div>
	);
};

export default DesktopDropdown;
